export const ordersConstants = {
  ignoreList: ['gateway', 'id', 'vehicle', 'type', 'status', 'creationDate'],
}
